const FiltersLocationsEnum = Object.freeze({
  country: {
    Čeština: 'Země : Vyberte',
    Deutsch: 'Land : Bitte wählen',
    Français: 'Pays : Sélectionner',
    Slovenčina: 'Krajina : Vyberte',
    Español: 'País : Seleccione',
    English: 'Country : Select',
  },
  state: {
    Čeština: 'Stát / region : Vyberte',
    Deutsch: 'Staat / Region : Bitte wählen',
    Français: 'État / Région : Sélectionner',
    Slovenčina: 'Štát / región : Vyberte',
    Español: 'Estado / Región : Seleccione',
    English: 'State / Region: Select',
  },
  location: {
    Čeština: 'Lokalita : Vyberte',
    Deutsch: 'Ort : Bitte wählen',
    Français: 'Lieu : Sélectionner',
    Slovenčina: 'Lokalita : Vyberte',
    Español: 'Ubicación : Seleccione',
    English: 'Location : Select',
  },
  category: {
    Čeština: 'Pracovní kategorie : Select',
    Deutsch: 'Job Kategorie : Bitte wählen',
    Français: "Catégorie d'emploi : Sélectionner",
    Slovenčina: 'Kategória práce : Vybrať',
    Español: 'Categoría de trabajo : Seleccionar',
    English: 'Job Category : Select',
  },
})

export default FiltersLocationsEnum
